export { IconAsset } from './IconAsset';
export { IconAssetBoat } from './IconAssetBoat';
export { IconAssetCar } from './IconAssetCar';
export { IconAssetCaravan } from './IconAssetCaravan';
export { IconAssetGreenGoods } from './IconAssetGreenGoods';
export { IconAssetOther } from './IconAssetOther';
export { IconAssetOtherVehicles } from './IconAssetOtherVehicles';
export { IconAssetPrimeMover } from './IconAssetPrimeMover';
export { IconAssetTrailer } from './IconAssetTrailer';
export { IconAssetTruck } from './IconAssetTruck';
export { IconAssetTruckHeavy } from './IconAssetTruckHeavy';
export { IconAssetType } from './IconAssetType';
export { IconAssetYellowGoods } from './IconAssetYellowGoods';
